import { noAuthRpcClient, rpcClient } from '../../rpcClient';
import { getProductsRpc as getInAppProductsRpc } from '../../../__generated__/chirp/com/hubspot/buying/rpc/ProductRpc';
import { getProductsRpc as getPublicProductsRpc } from '../../../__generated__/chirp/com/hubspot/buying/rpc/PublicProductRpc';
import { logRavenException } from '../../errorUtils';
export const fetchProducts = ({
  productApiNames,
  skuCategoryName,
  isPublicUseCase
}) => {
  let products = [];
  let promiseError = undefined;

  // Free api names (e.g. "marketing-hub-free") are a concept supported
  // exclusively by the feature store service.
  const purchasableApiNames = productApiNames.filter(apiName => !apiName.includes('free'));
  const productsPromise = isPublicUseCase ? noAuthRpcClient.call(getPublicProductsRpc, {
    request: {
      productApiNames: purchasableApiNames
    }
  }) : rpcClient.call(getInAppProductsRpc, {
    request: {
      productApiNames: purchasableApiNames
    }
  });
  return productsPromise.then(productsResponse => {
    products = Object.entries(productsResponse.productsByName).map(([productApiName, product]) => Object.assign({}, product, {
      productApiName
    }));
  }, error => {
    promiseError = error;
    logRavenException({
      error,
      customMessage: error.message,
      additionalDetails: {
        productApiNames
      }
    });
  }).catch(error => {
    promiseError = error;
    logRavenException({
      error,
      customMessage: 'fetchProducts: Promise successfully resolved but the catch block was triggered',
      additionalDetails: {
        productApiNames
      }
    });
  }).then(() => {
    if (promiseError) {
      console.error(promiseError);
    }
    const areAllProductsInSameProductLine = products && products.length > 0 && products.every(product => product.skuCategoryName === skuCategoryName);
    if (!areAllProductsInSameProductLine) {
      // Reset products to an empty array to prevent downstream fetches from
      // being fired
      products = [];
      const invalidProductApiNamesError = new Error(`Product details for ${purchasableApiNames.join(', ')} do not match the expected skuCategoryName: ${skuCategoryName}`);
      console.error(invalidProductApiNamesError);
      logRavenException({
        error: invalidProductApiNamesError,
        customMessage: invalidProductApiNamesError.message,
        additionalDetails: {
          productApiNames,
          skuCategoryName
        }
      });
    }
    return products;
  });
};